/* eslint-disable indent */
    var trackingUtils = require('../modules/utils/tracking.utils');
    var random = require('../modules/utils/random.js');
    var commaSeparator = /\s*,\s*/;

    Odigeo.defineWidget('persuasiveMessaging', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            defaults: {
                ids: {},
            },

            ids: {
                searchId: function() {
                    var params = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
                    return Odigeo._.map(params.searchSegments, function(segment) {
                        return segment.dateStr + ':' + segment.departure.iata + ':' + segment.destination.iata;
                    }).join(',');
                },
            },

            init: function() {
                this.widget.options = Odigeo.parseOptions(this.widget.options);
            },
            addId: function() {
                var onceShownPerIdType = this.widget.options.onceShownPerIdType;
                if (!Odigeo._.isString(onceShownPerIdType)) {
                    this.trigger('new:id');
                } else {
                    var fnId = this.ids[onceShownPerIdType];
                    var id = Odigeo._.isFunction(fnId) ? fnId() : fnId;
                    var ids = this.getIdCollection();
                    if (!ids[id]) {
                        ids[id] = true;
                        this.setIdCollection(ids);
                        this.trigger('new:id');
                    }
                }
            },

            getIdCollection: function() {
                var ids = this.get('ids');
                if (Odigeo._.isEmpty(ids)) {
                    var idsString = Odigeo.Session.get(this.widget.id + ':ids');
                    ids = idsString ? (Odigeo.Utils.parseJson(idsString) || {}) : {};
                }
                return ids;
            },

            setIdCollection: function(ids) {
                Odigeo.Session.set(this.widget.id + ':ids', JSON.stringify(ids));
            },

            getSessionValue: function(reference) {
                if (Odigeo._.isUndefined(reference)) {
                    return;
                }
                var index = reference.indexOf('.');
                var pos = index === -1 ? reference.length : index;
                var sessionKey = reference.substring(1, pos);
                var path = reference.substring(pos + 1);
                var sessionValue = Odigeo.Utils.parseJson(Odigeo.Session.get(sessionKey));
                return Odigeo._.get(sessionValue, path);
            },
        }),

        viewClass: Odigeo.View.extend({
            translations: {},
            templateSettings: Odigeo.Utils.getTmplSettings({variable: ''}),
            events: {
                'tap .persuasive_message_close': 'closeMessage',
                'mouseenter .persuasive_message': 'clearShownLimitTime',
                'mouseleave .persuasive_message': 'applyShownLimitTime',
            },
            selectors: {
                persuasiveMessage: '.persuasive_message',
            },

            init: function() {
                var templates = this.widget.options.template.split(commaSeparator);
                var templateText = $(Odigeo._.sample(templates)).html();
                this.shownLimitTimeId = null;
                this.translations = Odigeo._.extend({}, Odigeo.UIElements.translations.persuasiveMessages);
                this.template = Odigeo._.template(templateText, this.templateSettings);
                this.model.on('new:id', this.showMessage, this);
                this.$cachedSelectors.persuasiveMessage.toggleClass('odf-hidden', !!this.widget.options.stayClosed);
                if (this.widget.options.autoload) {
                    this.updatePageAndMessage(this.widget.options.autoload);
                }
                if (this.$cachedSelectors.persuasiveMessage.hasClass('closed')) {
                    this.$cachedSelectors.persuasiveMessage.addClass('odf-hidden');
                }
                Odigeo.trigger(this.widget.name + ':removeMessages', this.page);
            },

            computeTemplateParams: function(page) {
                var idWidget = this.widget.options.idWidget;
                var translations = idWidget ? this.translations[idWidget] : this.translations[page];

                Odigeo._.extend(translations, {
                    clusterText: translations['default'],
                });

                return Odigeo._.reduce(Odigeo._.keys(translations), Odigeo._.bind(function(params, key) {
                    var message = translations[key];
                    if (!Odigeo._.isEmpty(message) && message[0] === '$') {
                        message = this.model.getSessionValue(message);
                    }
                    params[key] = random(message);
                    return params;
                }, this), {});
            },

            activateMessage: function(page) {
                this.page = page;
                if (this.isShowable()) {
                    this.$cachedSelectors.persuasiveMessage.attr('data-page', '');
                    this.model.addId();
                }
            },

            closeMessage: function() {
                var trackAction = this.widget.options.trackAction;
                this.shownLimitTimeId = null;
                this.$cachedSelectors.persuasiveMessage.addClass('closed').removeClass('active');
                if (this.page && this.isShowable()) {
                    this.translations[this.page].closed = true;
                }
                if (trackAction) {
                    trackingUtils.trackEvent(trackAction, trackAction + '_layer_closed');
                }
            },

            deactivateMessage: function() {
                this.$cachedSelectors.persuasiveMessage.removeClass('active closed');
            },

            isShowable: function() {
                var isShown = false;
                if (this.widget.options.showOncePerSearch) {
                    isShown = Odigeo.Session.get('isFirstSearch') === 'false';
                }
                return !isShown && this.translations && this.template && this.translations[this.page];
            },

            updatePageAndMessage: function(page) {
                this.page = page;
                if (this.isShowable() && !this.translations[page].closed) {
                    this.$cachedSelectors.persuasiveMessage.attr('data-page', '');
                    this.model.addId();
                } else {
                    this.$cachedSelectors.persuasiveMessage.addClass('closed');
                }
            },

            showMessage: function() {
                var appearanceDelayTime = this.widget.options.appearanceDelayTime;
                appearanceDelayTime = Odigeo._.isNumber(appearanceDelayTime) ? appearanceDelayTime : 0;
                Odigeo._.delay(Odigeo._.bind(function() {
                    this.createMessage();
                }, this), appearanceDelayTime);
            },

            createMessage: function() {
                var templateParams = this.computeTemplateParams(this.page);
                this.$cachedSelectors.persuasiveMessage.empty().append(this.template(templateParams));
                this.$cachedSelectors.persuasiveMessage
                    .addClass('active')
                    .attr('data-page', this.page);

                this.applyShownLimitTime();
            },

            applyShownLimitTime: function() {
                if (Odigeo._.isNull(this.shownLimitTimeId) && Odigeo._.isNumber(this.widget.options.shownLimitTime)) {
                    this.shownLimitTimeId = Odigeo._.delay(Odigeo._.bind(this.closeMessage, this), this.widget.options.shownLimitTime);
                }
            },

            clearShownLimitTime: function() {
                if (Odigeo._.isNumber(this.shownLimitTimeId)) {
                    clearTimeout(this.shownLimitTimeId);
                    this.shownLimitTimeId = null;
                }
            },

            updateKey: function(key, text) {
                var idWidget = this.widget.options.idWidget;
                var translationElement = idWidget ? idWidget : this.page;
                var trackAction = this.widget.options.trackAction;

                this.translations[translationElement][key] = text;
                this.createMessage();
                this.$cachedSelectors.persuasiveMessage.removeClass('odf-hidden closed');
                this.widget.options.stayClosed = false;
                Odigeo.trigger(this.widget.name + ':removeMessages', this.page);
                if (trackAction) {
                    trackingUtils.trackEvent(trackAction, trackAction + '_layer_appearances');
                }
            },

            hide: function() {
                this.$cachedSelectors.persuasiveMessage.addClass('odf-hidden');
            },
        }),

        activateMessage: function(page) {
            this.view.activateMessage(page);
        },

        deactivateMessage: function() {
            this.view.deactivateMessage();
        },

        closeMessage: function() {
            this.view.closeMessage();
        },

        updateKey: function(key, text) {
            this.view.updateKey(key, text);
        },

        hideWidget: function() {
            this.view.hide();
        },

        init: function() {
            this.options = Odigeo.parseOptions(this.options);
        },
    }));
